import React from "react";
import numeral from "numeral";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import { createUserInfoQuery } from "containers/Login/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import uploadDatasetIcon from "images/tileIcons/uploadDataset.svg";
import tableauIcon from "images/tableau.png";
import trayIcon from "images/tray_io_logo.png";

import CreateTile from "components/Tiles/CreateTile";

import datasetWhiteIcon from "images/tileIcons/dataset_white.svg";

import BoomiIcon from "images/G/Boomi.svg";
import SparkIcon from "images/G/Spark.svg";

import { getDatasetNeedsReindex } from "containers/Upload/reducer";
import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { DATA_SOURCES } from "containers/SchemaMonitor/reducer";

import FeedbackContainer from "containers/Gallery/Feedback";

import SchemaMonitorContainer from "components/SchemaMonitor/SchemaMonitor";

import getStyles from "components/Home/Utils/getStyles";

import { Icon } from "components/Home/Utils/Utils";

import styles from "./style.module.css";

import MySQLIcon from "images/EDG/DB/MYSQL.svg";
import PostgreSQLIcon from "images/EDG/DB/POSTGRES.svg";
import AWSIcon from "images/EDG/DB/AWS.svg";
import AzureIcon from "images/EDG/DB/AZURE.svg";
import SnowflakeIcon from "images/EDG/DB/snowflake.svg";
import TerradataIcon from "images/EDG/DB/Teradata.png";

import MarketoIcon from "images/G/Marketo.svg";
import WhatIcon from "images/G/What.svg";
import SalesforceIcon from "images/G/Salesforce.svg";
import SapIcon from "images/G/Sap.svg";
import NewOracleIcon from "images/G/Oracle.svg";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const dataStyles = getStyles("dataset");

export default class DatasetTile extends React.PureComponent {
  state = {
    isHover: false,
    isLoadingFeedback: false
  };

  handleOnClick(event) {
    const { onHover, onClick } = this.props;
    onHover && onHover(undefined);
    return onClick(event);
  }

  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  render() {
    const {
      dataset,
      outcomeType,
      isCreate,
      isCreateDisabled,
      isDataUploading,
      isTabUploading,
      isTableau,
      isTrayUploading,
      isTray,
      isHighlight,
      isLink,
      linkType,
      onHover,
      isConsumer,
      shouldHighlight,
      hideDelete,
      handleDelete,
      updateIsLinkMode,
      analyzedOutcomes,
      updateIsBoomiLinkMode,
      isDataMode,
      isAiReady,
      isMultiCategoryOutcome,
      aiReadyOutcomes,
      noHover,
      history,
      isForecastReady,
      userInfoQuery
    } = this.props;

    // For Removing onClick in Data Mode error;
    let { onClick } = this.props;

    let { isHover } = this.state;
    isHover = onClick && isHover;

    if (isTableau || isTray) {
      return (
        <UploadDatasetTile
          isTableau={isTableau}
          isTray={isTray}
          loading={isTabUploading || isTrayUploading ? "Importing..." : undefined}
          onClick={onClick}
        />
      );
    }

    if (isCreate) {
      return (
        <UploadDatasetTile
          loading={isDataUploading ? "Uploading..." : undefined}
          isCreateDisabled={isCreateDisabled}
          onClick={onClick}
        />
      );
    }

    if (isLink) {
      return linkType === "BOOMI" || getIsEDG() ? (
        <LinkDatasetTileEDG
          loading={isDataUploading ? "Linking..." : undefined}
          linkDataset={onClick}
          isCreateDisabled={isCreateDisabled}
          updateIsLinkMode={updateIsLinkMode}
          updateIsBoomiLinkMode={updateIsBoomiLinkMode}
          linkType={linkType}
        />
      ) : (
        <React.Fragment>
          <LinkDatasetTileEDGOld
            loading={isDataUploading ? "Linking..." : undefined}
            linkDataset={onClick}
            isCreateDisabled={isCreateDisabled}
            updateIsLinkMode={updateIsLinkMode}
          />
          <SchemaMonitorContainer />
        </React.Fragment>
      );
    }

    if (!dataset) {
      return <React.Fragment></React.Fragment>;
    }

    const noOutcome = dataset.status && dataset.status.indexOf("missing_target_variable") !== -1;

    const finishedIndexing =
      dataset.status &&
      dataset.status.indexOf("indexing") === -1 &&
      dataset.status.indexOf("finishing_indexing") === -1 &&
      !dataset.stack_id;

    const isShell = dataset.status_name === "NOT_STARTED" && dataset.labels.length === 0 && dataset.stack_id == null;

    const isError = dataset?.dataset_status === "ERROR";
    const noFileError =
      isError &&
      dataset &&
      dataset.errors &&
      dataset.errors.find((record) => record.message === "Didn't detect properly as a CSV!");

    const needsReindex = getDatasetNeedsReindex(dataset) || isShell || noFileError;

    const isDone = dataset.rowCount !== -1 || (finishedIndexing && noOutcome);

    const isLoading = !isDone && !isError;

    let triggerImg = <Icon src={datasetWhiteIcon} color={dataStyles.color} />;
    let buttonText = "";
    let triggerHover = false;

    const columns = dataset && dataset.fields ? Object.keys(dataset.fields) : false;
    const columnCount = columns ? columns.length : 0;
    const rowCount = dataset.rowCount ? dataset.rowCount : 0;

    let titleColor = "default";
    let titleIcon = "dataDefault";
    let errorText = undefined;
    let showError = false;
    let buttonOverlay = undefined;

    let subtitleText = undefined;
    let subtitleIcon = undefined;

    let datasetOutcome = dataset.outcome || "";

    if (isShell) {
      showError = true;
      errorText = "This is a placeholder dataset. Please upload your data and refresh";

      buttonText = "Get Upload Url";

      const splitUrl = dataset.source.url.split("/");

      const uploadId = splitUrl[splitUrl.length - 2];

      buttonOverlay = <div style={{ wordWrap: "break-word" }}>{`${window.location.origin}/upload/${uploadId}`}</div>;
    }

    if (isError && !isShell) {
      showError = true;
      titleIcon = "dataInvalid";
      titleColor = noFileError ? "default" : "red";
      errorText = "We encountered an error while evaluating the dataset.";
      if (isDataMode) {
        errorText = (
          <a
            className={styles.errorCTA}
            onClick={(e) => {
              e.stopPropagation();
              window.open(
                "https://enaible.aible.com/aible-data-ask-an-expert" + (userInfoQuery ?? createUserInfoQuery()),
                "_blank"
              );
            }}
          >
            {"We found issues with your dataset. Click here to have one of our experts help you out."}
          </a>
        );
      } else {
        buttonText = "View Error";
        buttonOverlay = (
          <React.Fragment>
            {dataset.errors &&
              dataset.errors.map((error, i) => {
                const errorMessage = error.message
                  ? error.message === "Didn't detect properly as a CSV!"
                    ? "No file has been uploaded. Please upload a file and try refreshing the tile"
                    : error.message
                  : error;
                return (
                  <div className={styles.oField} key={error && error.message + " " + i}>
                    {errorMessage}
                  </div>
                );
              })}
            <div className={styles.oField}>
              <div className={styles.oSubfield}>{"Dataset ID: " + (dataset && dataset.id)}</div>
              {dataset && dataset.source ? (
                <div className={styles.oSubfield}>{"Source URL: " + dataset.source.url}</div>
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        );
      }
    } else {
      if (isDone) {
        if (noOutcome && !isConsumer && !needsReindex) {
          buttonText = "Select Outcome";
          subtitleText = "Select Outcome to Continue";
          datasetOutcome = <i>{"Pending..."}</i>;
        } else {
          if (needsReindex) {
            buttonText = "Refresh Data";
            subtitleText = "Dataset Requires Refresh";
          } else {
            buttonText = "Use Dataset";
            if (isConsumer) {
              if (aiReadyOutcomes && aiReadyOutcomes.length > 0) {
                titleIcon = "dataValid";
                titleColor = "green";
                subtitleText = aiReadyOutcomes.length + " AI Ready Outcome" + (aiReadyOutcomes.length > 1 ? "s" : "");
                subtitleIcon = "checkGreen";
              } else {
                titleIcon = "dataInvalid";
                titleColor = "default";
                subtitleText = "0 AI Ready Outcomes";
              }
            } else if (isAiReady) {
              titleIcon = "dataValid";
              titleColor = "green";
              subtitleText = "Outcome is AI Ready";
              subtitleIcon = "checkGreen";
            } else if (isMultiCategoryOutcome) {
              titleIcon = "dataDefault";
              titleColor = "default";
              subtitleText = undefined;
              subtitleIcon = undefined;
            } else if (isForecastReady) {
              titleIcon = "dataValid";
              titleColor = "green";
              subtitleText = "Outcome is Forecastable";
              subtitleIcon = "checkGreen";
            } else {
              titleIcon = "dataInvalid";
              titleColor = "red";
              subtitleText = "Outcome is not AI Ready";
              subtitleIcon = "timesRed";
            }
          }
        }
      }
    }

    const isTourDataset = dataset && dataset.id && (dataset.id === 2190 || dataset.id === 1181);

    return (
      <Tile
        onClick={onClick ? (e) => this.handleOnClick(e) : undefined}
        onMouseEnter={() => {
          onHover && onHover(dataset.id);
          return this.setState({ isHover: true });
        }}
        onMouseLeave={() => {
          onHover && onHover(undefined);
          return this.setState({ isHover: false });
        }}
        id={isTourDataset ? "aibleTourDataset" : undefined}
        buttonOverlay={buttonOverlay}
        buttonText={buttonText}
        handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
        active={isHighlight}
        noHover={noHover}
        showButton={(!isConsumer && noOutcome) || buttonOverlay ? true : undefined}
        isTileClick={!isConsumer && noOutcome ? true : undefined}
        noTitleClick={isError}
        shouldHighlight={shouldHighlight}
        hideDelete={hideDelete}
        buttons={
          isError
            ? undefined
            : [
                {
                  label: "Create",
                  onClick: onClick ? (e) => this.handleOnClick(e) : undefined
                },
                {
                  label: "Explore",
                  onClick: () => history.push("/gallery/" + dataset.id + (dataset.jId ? "/" + dataset.jId : ""))
                }
              ]
        }
      >
        <TileTitle
          title={`${dataset.label} (${dataset.id})${needsReindex ? " - Click to Refresh" : ""}`}
          icon={titleIcon}
          color={dataset.jId ? "#512f77" : titleColor}
          style={{ height: "40px" }}
        >
          {dataset.label}
        </TileTitle>
        <TileSubtitle
          icon={subtitleIcon}
          hide={
            isError ||
            isLoading ||
            (!subtitleText && !subtitleIcon) ||
            (onClick && (!subtitleText || isHover) && !(noOutcome && !isConsumer))
          }
        >
          {subtitleText}
        </TileSubtitle>
        <TileBody
          isLoading={isLoading}
          loadingText={
            <div className={styles.datasetLoadingText}>
              <div style={{ fontWeight: "bold" }}>{"Evaluating Data..."}</div>
              <div style={{ fontWeight: "normal" }}>
                {/* {"This should only take a couple minutes."} */}
                {"This typically takes from 5 to 15 minutes."}
              </div>
            </div>
          }
          isError={showError}
          errorText={errorText}
          color={"default"}
        >
          {datasetOutcome && !isConsumer ? (
            <TileItem
              icon={"target"}
              overlay={!noOutcome && outcomeType ? <div className={styles.oTitle}>{outcomeType}</div> : undefined}
              smallOverlay
            >
              {isConsumer && analyzedOutcomes && analyzedOutcomes.length > 1
                ? analyzedOutcomes.length + " outcomes"
                : datasetOutcome}
            </TileItem>
          ) : (
            ""
          )}
          {Boolean(isDone) && (
            <React.Fragment>
              <TileItem
                icon={"rows"}
                overlay={
                  Boolean(columns && columns.length) && (
                    <React.Fragment>
                      {columns.map((field, i) => (
                        <div className={styles.oField} key={field && field.label + " " + i}>
                          {field}
                          {dataset.fields && dataset.fields[field] && dataset.fields[field].type ? (
                            <em>{" (" + dataset.fields[field].type + ")"}</em>
                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                    </React.Fragment>
                  )
                }
              >
                {!noOutcome && (
                  <span className={styles.datasetRows}>
                    {(rowCount > 1000 ? numeral(rowCount).format("0.0a") : rowCount) + " Rows,"}
                  </span>
                )}
                {(columnCount > 1000 ? numeral(columnCount).format("0.0a") : columnCount) + " Columns"}
              </TileItem>
              <TileItem icon={"comment"}>
                <FeedbackContainer id={dataset.id} isTile />
              </TileItem>
            </React.Fragment>
          )}
          {dataset.created_by ? <TileItem icon={"user"}>{dataset.created_by.fullname}</TileItem> : ""}
          <TileItem icon={"calendar"} overlay={moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}>
            {moment.utc(dataset.created).local().fromNow()}
          </TileItem>
        </TileBody>
      </Tile>
    );
  }
}

export class LinkModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      type: "snowflake",
      name: "New Test File",
      url: undefined,
      account: undefined,
      user: undefined,
      password: undefined,
      database: undefined,
      table: undefined,
      schema: undefined,
      warehouse: undefined,
      tempdir: undefined
    };
  }
  render() {
    const { isOpen, onClose, onCreate } = this.props;

    const settings = [
      { label: "File Name", value: "name" },
      { label: "URL", value: "url" },
      { label: "Account", value: "account" },
      { label: "User", value: "user" },
      { label: "Password", value: "password", isPassword: true },
      { label: "Database", value: "database" },
      { label: "Table", value: "table" },
      { label: "Schema", value: "schema" },
      { label: "Warehouse", value: "warehouse" },
      { label: "Temp Directory (AWS Only)", value: "tempdir" }
    ];

    return (
      <Dialog open={isOpen} onOp={onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Link Snowflake Dataset</DialogTitle>
          </DialogHeader>

          <div>
            {settings.map((s, i) => (
              <LineInput
                key={i}
                isMediumBox
                value={this.state[s.value]}
                onChange={(val) => this.setState({ [s.value]: val })}
                label={s.label}
                labelStyle={{ width: "100px" }}
                isPassword={s.isPassword}
              />
            ))}
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => onClose()}>
              {"Close"}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onCreate({
                  url: this.state.url,
                  account: this.state.account,
                  user: this.state.user,
                  password: this.state.password,
                  database: this.state.database,
                  table: this.state.table,
                  schema: this.state.schema,
                  warehouse: this.state.warehouse,
                  tempdir: this.state.tempdir,
                  name: this.state.name
                });
                return onClose();
              }}
            >
              {"Create Dataset"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

export class LinkDatasetTile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isLinkModal: false };
  }

  render() {
    const { linkDataset, loading, isTableau, isTray, isCreateDisabled } = this.props;
    let image = uploadDatasetIcon;
    let title = loading || "Link Dataset";
    let text = loading || "Link Dataset";

    return (
      <div className={styles.tileWrapper}>
        <div
          className={!isCreateDisabled ? styles.tile : styles.tileNoHover}
          onClick={!isCreateDisabled ? () => this.setState({ isLinkModal: true }) : () => {}}
        >
          <div className={styles.createTileImageWrapper}>
            <div className={styles.createTileIcon}>
              {loading ? (
                <React.Fragment>
                  <LoadingIndicator color={isTray ? "#292945" : "var(--dataset-text)"} style={{ margin: "0px" }} />
                </React.Fragment>
              ) : (
                <img src={image} alt={text} />
              )}
            </div>
          </div>
          <div className={styles.createTileBody}>
            <div className={styles.createTileHeader + (isTray ? "" : " " + dataStyles.text)} title={title}>
              {isCreateDisabled ? (
                <div className={styles.tileErrorText}>
                  {"You don't have permission to link a dataset in this folder."}
                </div>
              ) : (
                text
              )}
            </div>
          </div>
        </div>
        <LinkModal
          isOpen={this.state.isLinkModal}
          onClose={() => this.setState({ isLinkModal: false })}
          onCreate={(settings) => linkDataset(settings)}
        />
      </div>
    );
  }
}

export class LinkDatasetTileEDGOld extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isLinkModal: false };
  }

  render() {
    const { updateIsLinkMode, loading, isCreateDisabled } = this.props;

    return (
      <React.Fragment>
        <CreateTile
          onClick={() => updateIsLinkMode(true)}
          noPermissions={isCreateDisabled}
          noPermissionsText={"You don't have permission to link a data source in this folder."}
          buttonText={"Link to Data Source"}
          isLoading={loading}
          loadingText={"Linking..."}
        >
          <div className={styles.linkIcons}>
            {DATA_SOURCES.map(
              (source) =>
                Boolean(source && !source.hide) && (
                  <img
                    className={styles.linkIcon}
                    key={"link-source-" + source.value}
                    src={source.image}
                    alt={source.label}
                  />
                )
            )}
          </div>
        </CreateTile>
      </React.Fragment>
    );
  }
}

export class LinkDatasetTileEDG extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isLinkModal: false };
  }

  render() {
    const { updateIsLinkMode, updateIsBoomiLinkMode, linkDataset, linkType, isCreateDisabled } = this.props;

    return (
      <div className={styles.tileWrapper}>
        <div
          className={!isCreateDisabled ? styles.tile : styles.tileNoHover}
          onClick={
            !isCreateDisabled
              ? linkType === "BOOMI"
                ? () => updateIsBoomiLinkMode(true)
                : () => updateIsLinkMode(true)
              : () => {}
          }
        >
          {linkType === "BOOMI" ? (
            <div className={styles.linkIcons}>
              <img className={styles.linkIcon} src={NewOracleIcon} alt={"Oracle"} />
              <img className={styles.linkIcon} src={MarketoIcon} alt={"Marketo"} />
              <img className={styles.linkIcon} src={WhatIcon} alt={"Azure"} />
              <img className={styles.linkIcon} src={SalesforceIcon} alt={"Salesforce"} />
              <img className={styles.linkIcon} src={SapIcon} alt={"SAP"} />
            </div>
          ) : (
            <div className={styles.linkIcons}>
              <img className={styles.linkIcon} src={TerradataIcon} alt={"Terradata"} />
              <img className={styles.linkIcon} src={SnowflakeIcon} alt={"Snowflake"} />
              <img className={styles.linkIcon} src={NewOracleIcon} alt={"Oracle"} />
              <img className={styles.linkIcon} src={MySQLIcon} alt={"MySQL"} />
              <img className={styles.linkIcon} src={PostgreSQLIcon} alt={"PostgreSQL"} />
              <img className={styles.linkIcon} src={AWSIcon} alt={"AWS"} />
              <img className={styles.linkIcon} src={AzureIcon} alt={"AZure"} />
            </div>
          )}
          <div className={styles.linkButton}>
            {isCreateDisabled ? (
              <div className={styles.tileErrorText}>
                {"You don't have permission to link a dataset in this folder."}
              </div>
            ) : (
              <Button style={{ paddingTop: "7px ", paddingBottom: "7px " }}>
                {linkType === "BOOMI" ? (
                  <span className={styles.bFlex}>
                    <img src={BoomiIcon} style={{ marginRight: "5px" }} alt={"Boomi Logo"} />
                    <span>{"Data Link"}</span>
                  </span>
                ) : (
                  <span className={styles.bFlex}>
                    <img src={SparkIcon} style={{ marginRight: "5px" }} />
                    <span>{"Spark Data Link"}</span>
                  </span>
                )}
              </Button>
            )}
          </div>
        </div>
        <LinkModal
          isOpen={this.state.isLinkModal}
          onClose={() => this.setState({ isLinkModal: false })}
          onCreate={(settings) => linkDataset(settings)}
        />
      </div>
    );
  }
}

export class UploadDatasetTile extends React.PureComponent {
  render() {
    const { onClick, loading, isTableau, isTray, isCreateDisabled } = this.props;
    let image = uploadDatasetIcon;
    let title = loading || "Upload Dataset to your cloud account";
    let text = loading || "Upload Dataset to your cloud account";
    if (isTableau) {
      image = tableauIcon;
      title = "Import Data - Current limit 10k rows";
      text = "Import Dataset";
    }
    if (isTray) {
      image = trayIcon;
      title = "Import Data";
      text = loading ? "Executing Recipe" : "Use Data Recipe";
    }

    return (
      <div className={styles.tileWrapper}>
        <div
          className={onClick && !isCreateDisabled ? styles.tile : styles.tileNoHover}
          onClick={onClick && !loading && !isCreateDisabled ? () => onClick() : () => {}}
        >
          <div className={styles.createTileImageWrapper}>
            <div className={styles.createTileIcon}>
              {loading ? (
                <React.Fragment>
                  <LoadingIndicator color={isTray ? "#292945" : "var(--dataset-text)"} style={{ margin: "0px" }} />
                </React.Fragment>
              ) : (
                <img src={image} alt={text} />
              )}
            </div>
          </div>
          <div className={styles.createTileBody}>
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"All data will be securely stored in your organization’s cloud account"}</div>
                  <div>
                    {"All processes take place inside your cloud account and Aible only ever sees the metadata."}
                  </div>
                </Popover>
              }
            >
              <div
                className={styles.createTileHeader + (isTray ? "" : " " + dataStyles.text)}
                style={{ textTransform: "none" }}
                title={title}
              >
                {isCreateDisabled ? (
                  <div className={styles.tileErrorText}>
                    {"You don't have permission to upload a dataset in this folder."}
                  </div>
                ) : (
                  text
                )}
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    );
  }
}
